import React, { Component, PropTypes } from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';

import GeneralInfo from './general-info';
import Contacts from './contacts';
import ContractingFiles from './contracting-files';
import NewActivity from './new-activity';
import Activities from './activities';

const styles = {
  content: {
    backgroundColor: 'rgb(240, 244, 247)',
    minHeight: 'calc(100% - 65px)',
    paddingLeft: '0 !important',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    marginTop: '65px',
    flexFlow: 'row wrap',
    textAlign: 'content',
    '& > *': {
      flex: '1 100%',
    },
  },
  main: {
    textAlign: 'left',
    '@media all and (min-width: 800px)': {
      flex: '3 0px',
      order: '2',
    },
  },
  leftColumn: {
    '@media all and (min-width: 600px)': {
      flex: '1 0 0',
    },
    '@media all and (min-width: 800px)': {
      order: '1',
    },
  },
  errorOverlay: {
    height: '100%',
    width: '100%',
    position: 'fixed',
    zIndex: 1000,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    overflowX: 'hidden',
    transition: '0.5s',
    textAlign: 'center',
    paddingTop: '20%',
  },
  errorText: {
    color: 'white',
    marginTop: '24px',
    fontSize: '24px',
    whiteSpace: 'pre-wrap',
    width: '50%',
    margin: 'auto',
  },
};

class partnerDetails extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.content}>
        <div className={classes.leftColumn}>
          <GeneralInfo />
          <Contacts />
          <ContractingFiles />
        </div>
        <div className={classes.main}>
          <NewActivity />
          <Activities />
        </div>
        {
          Boolean(this.props.error) && (
            <div className={classes.errorOverlay}>
              <div className={classes.errorText}>{this.props.error}</div>
            </div>
          )
        }
      </div>
    );
  }
}

partnerDetails.propTypes = {
  classes: PropTypes.object,
};

const select = ({ partnerDetails: store }) => ({
  partnerInfo: store.partnerInfo,
  error: store.error,
});

export default connect(select, {})(injectSheet(styles)(partnerDetails));



// WEBPACK FOOTER //
// ./src/app/components/partner-details/index.jsx